import React, { MouseEvent } from 'react';
import { Icon, IconSymbol } from 'elements';

interface CareerFilterProps {
  children: React.ReactNode;
  iconName?: IconSymbol;
  onClick: () => void;
  onClearFilter?: () => void;
  isDropdownOpen: boolean;
}

const CareerFilterTag: React.FC<CareerFilterProps> = ({
  children,
  iconName,
  onClick,
  onClearFilter,
  isDropdownOpen,
}) => {
  const onClearFilterClick = (event: MouseEvent) => {
    event.stopPropagation();
    if (onClearFilter) {
      onClearFilter();
    }
  };

  return (
    <button className='career-filter-tag' onClick={onClick}>
      {iconName && <Icon name={iconName} fill={'#5D76BF'} zoom='1.5em' />}
      <span className='filter-label'>{children}</span>
      {onClearFilter ? (
        <button className='close-button' onClick={onClearFilterClick}>
          <Icon name='career-close' fill={'#497595'} />
        </button>
      ) : (
        <Icon
          name={isDropdownOpen ? 'accordion-opened' : 'accordion-closed'}
          fill={'#497595'}
        />
      )}
    </button>
  );
};

export default CareerFilterTag;
